<template>
	<div class="ks-videoeditor-inspector-body">
		<k-text-field label="Title" :value="overlay.title" @input="update({title: $event})"></k-text-field>
		<div class="ks-videoeditor-inline">
			<k-text-field label="Start (s)" type="number" :value="round(overlay.start)" @input="set_start"></k-text-field>
			<k-text-field label="Duration (s)" type="number" :value="round(overlay.duration)" @input="set_duration"></k-text-field>
		</div>
		<div class="ks-videoeditor-meta">Ends at {{ fmt(overlay.start + overlay.duration) }}</div>

		<frame-position :item="overlay" full_title="Full frame" @preset="$emit('preset', overlay, $event)" @change="update"></frame-position>
		<div class="ks-videoeditor-meta">Drag the image in the preview to move it, drag the corners to resize.</div>

		<div class="ks-videoeditor-inspector-title">Opacity</div>
		<slider-field :value="overlay.opacity" @input="update({opacity: $event})"></slider-field>

		<transition-field title="Transition in" :value="in_transition(overlay)" @input="update({transition: $event})"></transition-field>
		<transition-field title="Transition out" :value="out_transition(overlay)" @input="update({transition_out: $event})"></transition-field>

		<div class="ks-videoeditor-inline ks-videoeditor-actions">
			<k-btn size="s" icon icon-name="my_location" @click="$emit('start-at-playhead', overlay)">Start at playhead</k-btn>
			<k-btn size="s" icon icon-name="content_copy" @click="$emit('duplicate-overlay', overlay)"></k-btn>
			<k-btn size="s" color="error" icon icon-name="delete" @click="$emit('remove-overlay', overlay)"></k-btn>
		</div>
	</div>
</template>

<script>
import {MIN_LEN} from './constants.js'
import FramePosition from './FramePosition.vue'
import SliderField from './SliderField.vue'
import TransitionField from './TransitionField.vue'
import {fmt, in_transition, out_transition, round} from './utils.js'

// Properties of an image overlay; changes are emitted as update(item, patch)
export default {
	components: {FramePosition, SliderField, TransitionField},
	props: {
		overlay: Object
	},
	methods: {
		fmt,
		round,
		in_transition,
		out_transition,
		update (patch) {
			this.$emit("update", this.overlay, patch);
		},
		set_start (value) {
			const v = parseFloat(value);
			if (!isNaN(v)) this.update({start: Math.max(0, v)});
		},
		set_duration (value) {
			const v = parseFloat(value);
			if (!isNaN(v)) this.update({duration: Math.max(MIN_LEN, v)});
		}
	}
}
</script>
